const Hooks = {};

function serialize(form) {
  const data = new FormData(form);
  const object = {};

  data.entries().forEach(([key, value]) => {
    // Split nested input names
    const [inputGroup, fieldName] = key.split('[').map((str) => str.replace(']', ''));

    if (fieldName === undefined) {
      // Wasn't a nested input name
      object[key] = value;
    } else if (object[inputGroup] === undefined) {
      // create an object for this inputGroup
      object[inputGroup] = { [fieldName]: value };
    } else {
      object[inputGroup][fieldName] = value;
    }
  });
  return object;
}

// Takes the answer a user gives for a question and applies it to the question for each individual
// contact having their status updated.
Hooks.ApplyAnswerToAll = {
  mounted() {
    this.el.addEventListener('click', () => {
      const fieldName = this.el.getAttribute('data-field-name');
      const fieldType = this.el.getAttribute('data-field-type');
      const form = document.getElementById('create-requests-form');
      let givenValue;

      if (fieldType === 'checkbox') {
        givenValue = document.getElementById(`apply-to-all-form_${fieldName}`).checked;
      } else if (fieldType === 'multiselect') {
        const { options } = document.getElementById(`apply-to-all-form_${fieldName}`);

        givenValue = [];
        for (let i = 0; i < options.length; i += 1) {
          if (options[i].selected) {
            givenValue.push(options[i].value);
          }
        }
      } else if (fieldType === 'lookup') {
        givenValue = document.querySelector(`[name='apply_all_questions[${fieldName}]']`).value;
      } else {
        givenValue = document.getElementById(`apply-to-all-form_${fieldName}`).value;
      }

      // Get list of all input elements that have id ending in the field name
      const contactInputs = document.querySelectorAll(`[id$='${fieldName}']`);

      for (let i = 0; i < contactInputs.length; i += 1) {
        if (fieldType === 'checkbox') {
          contactInputs[i].checked = givenValue;
        } else if (fieldType === 'multiselect') {
          if (contactInputs[i].tagName === 'SELECT') {
            const { options } = contactInputs[i];
            for (let j = 0; j < options.length; j += 1) {
              if (givenValue.includes(options[j].value)) {
                options[j].selected = true;
              } else {
                options[j].selected = false;
              }
            }
          }
        } else {
          contactInputs[i].value = givenValue;
        }
      }

      if (fieldType === 'lookup') {
        // Get human readable (non-id) value
        const humanValue = this.el.parentElement.parentElement
          .querySelector('.profile-field-value')
          .textContent.trim();
        const lookupInputs = document.querySelectorAll(`[id^='input_lookup_${fieldName}']`);

        for (let i = 0; i < lookupInputs.length; i += 1) {
          lookupInputs[i].value = humanValue;
        }
      }

      // Trigger change event to update progress bars
      form.dispatchEvent(new Event('change'));

      // Trigger the form's change handler with the updated form data so that the values are
      // preserved in socket assigns.
      const params = serialize(form);
      this.pushEvent('contacts_form_changed', params);
    });
  },
};

const setProgressBarValues = () => {
  const allRelationshipsQuestions = document.querySelectorAll('.relationship-questions');

  allRelationshipsQuestions.forEach((relQuestions) => {
    const inputs = relQuestions.querySelectorAll(
      "input[data-field-required]:not([type='hidden']),select,textarea,checkbox",
    );
    let answeredCount = 0;

    for (let i = 0; i < inputs.length; i += 1) {
      if (inputs[i].type === 'checkbox' && inputs[i].checked) {
        answeredCount += 1;
      } else if (inputs[i].type !== 'checkbox' && inputs[i].value) {
        answeredCount += 1;
      }
    }

    // Percentage of answered questions
    const progress = answeredCount / inputs.length;

    // Update the progress bar
    const relationshipId = relQuestions.getAttribute('data-relationship-hcpg-id');
    const progressBar = document.getElementById(`progress-bar-${relationshipId}`);
    progressBar.value = progress;
  });
};

// Calculates and sets progress bars on each individual Relationship having its status changed
Hooks.UpdateProgress = {
  mounted() {
    setProgressBarValues();
    this.el.addEventListener('change', () => {
      setProgressBarValues();
    });
  },
  updated() {
    // Running this at update recalculates progress bars after form submission so they don't reset
    setProgressBarValues();
  },
};

// Status Updater drag and drop reordering members in batch
Hooks.StatusUpdaterDragAndDrop = {
  mounted() {
    window.statusUpdaterDnd = this;
  },

  dragstart(event) {
    event.dataTransfer.setData('text/plain', event.target.id);
  },

  dragenter(event) {
    event.preventDefault();
  },

  dragover(event) {
    event.preventDefault();

    // Highlight dropdoze currently over
    if (event.target) {
      event.target.closest('.contact-drop-zone').classList.add('on-dragover');
    }
  },

  dragleave(event) {
    // Remove highlight from dropzone
    if (event.target) {
      event.target.closest('.contact-drop-zone').classList.remove('on-dragover');
    }
  },

  dragend(event) {
    event.preventDefault();
  },

  drop(event) {
    event.preventDefault();

    const draggingRelationship = document.getElementById(event.dataTransfer.getData('text/plain'));
    const targetRelationship = event.target.closest('.panel-block');

    this.reorderRelationship(draggingRelationship, targetRelationship);

    // Remove highlight from droppable zones
    document.querySelectorAll('.contact-drop-zone').forEach((element) => {
      element.classList.remove('on-dragover');
    });
  },

  reorderRelationship(draggingRelationship, targetRelationship) {
    const draggingId = draggingRelationship.id.replace('relationship-', '');
    const draggingSequenceInput = document.getElementById(
      `${draggingId}_csp__batch_sequence_number__c`,
    );

    const targetId = targetRelationship.id.replace('relationship-', '');
    const targetSequenceInput = document.getElementById(
      `${targetId}_csp__batch_sequence_number__c`,
    );

    if (draggingSequenceInput.value < targetSequenceInput.value) {
      // Insert dragged element after the target element
      targetRelationship.insertAdjacentElement('afterend', draggingRelationship);
    } else if (draggingSequenceInput.value > targetSequenceInput.value) {
      // Insert dragged element before the target element
      targetRelationship.insertAdjacentElement('beforebegin', draggingRelationship);
    }

    // Set Batch Sequence Numbers to the same order as they appear on the page after drag and drop
    this.setBatchSequenceNumbers();
  },

  setBatchSequenceNumbers() {
    const relationshipIdsInOrder = [];

    document.querySelectorAll('.batch-sequence-number-input').forEach((input, index) => {
      relationshipIdsInOrder[index] = input.id.replace('_csp__batch_sequence_number__c', '');
    });

    // Disable form submission button while we wait for server response
    const btn = document.querySelector('button#status-change-request-save[type=submit]');
    btn.classList.add('is-loading');
    btn.disabled = true;

    // Send new Contacts sequence to server
    this.pushEvent(
      'reorder-contacts',
      {
        relationship_ids_in_order: relationshipIdsInOrder,
      },
      // eslint-disable-next-line no-unused-vars
      (reply, ref) => {
        if (reply && 'status' in reply) {
          // Re-enable form submission button
          btn.classList.remove('is-loading');
          btn.disabled = false;
        }
      },
    );
  },
};

export default Hooks;
